import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePageSeo from '../hooks/usePageSeo';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HomeHero from '../components/landing/home/HomeHero';
import HomeStats from '../components/landing/home/HomeStats';
import HomePendingActions from '../components/landing/home/HomePendingActions';
import HomeSecurity from '../components/landing/home/HomeSecurity';
import HomeTestimonials from '../components/landing/home/HomeTestimonials';
import HomeLenny from '../components/landing/home/HomeLenny';
import HomePricing from '../components/landing/home/HomePricing';
import HomeSolutions from '../components/landing/home/HomeSolutions';
import HomeFAQ from '../components/landing/home/HomeFAQ';
import HomeBlogPreview from '../components/landing/home/HomeBlogPreview';
import HomeContact from '../components/landing/home/HomeContact';

/*
 * Homepage — sales page. Order is deliberate:
 * hero + demo video → proof (stats) → security → pending actions (3 questions)
 * → testimonials → Lenny + support → pricing → verticals (SEO + lead band)
 * → FAQ (SEO, JSON-LD) → guides (SEO) → contact.
 * Header nav anchors: #hero, #features (video), #pricing, #faq, #contact.
 */
function LandingPage() {
  const location = useLocation();

  usePageSeo({
    title: "תוכנה לניהול קליניקה – יומן, תשלומים ותיק מטופל | CliniKit (קליניקיט)",
    description: "CliniKit (קליניקיט) – תוכנה לניהול קליניקה הכי קלה בישראל: יומן תורים עם כל האפשרויות, תזכורות WhatsApp, דפי תשלום וסליקת אשראי, חשבוניות, תיק מטופל וסיכומי AI. מאובטח ברמה רפואית, תמיכה אישית, מחיר משתלם. לכל קליניקה וסטודיו – 30 יום חינם.",
    path: "/",
  });

  useEffect(() => {
    const sectionId = location.state?.scrollTo || location.hash?.replace('#', '');
    if (sectionId) {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location.state, location.hash]);

  return (
    <>
      <Header />
      <main>
        <HomeHero />
        <HomeStats />
        <HomeSecurity />
        <HomePendingActions />
        <HomeTestimonials />
        <HomeLenny />
        <HomePricing />
        <HomeSolutions />
        <HomeFAQ />
        <HomeBlogPreview />
        <HomeContact />
      </main>
      <Footer />
    </>
  );
}

export default LandingPage;
